import { render, staticRenderFns } from "./result.vue?vue&type=template&id=e4fc6a7a&scoped=true&"
import script from "./result.js?vue&type=script&lang=js&"
export * from "./result.js?vue&type=script&lang=js&"
import style0 from "./result.scss?vue&type=style&index=0&id=e4fc6a7a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4fc6a7a",
  null
  
)

export default component.exports